import React, { useRef } from 'react';
import { PeekBox, PeekStack } from '@piiqtechnologies/ui-components';
import { FullScreenControl } from '../../../components/full-screen-ctrl/index.js';
import { StagedControl } from '../../../components/staged-ctrl/index.js';
import { RoomsControl } from './rooms-control/RoomsControl.js';
import { NotEditableTooltip } from './NotEditableTooltip.js';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';

const EditorBaseMenu = () => {
    const baseMenuRef = useRef(null);
    const { getContainer } = usePannellumViewer();
    return (React.createElement(PeekBox, { ref: baseMenuRef, sx: { position: "absolute", bottom: "0", left: "0", zIndex: 1 }, width: "100%" },
        React.createElement(NotEditableTooltip, { baseMenuRef: baseMenuRef }),
        React.createElement(PeekStack, { sx: { p: 2 }, direction: "row", alignItems: "center", justifyContent: "space-btween", spacing: 1 },
            React.createElement(PeekBox, null,
                React.createElement(RoomsControl, null)),
            React.createElement(PeekBox, { flexGrow: 1 }),
            React.createElement(PeekStack, { direction: "row", justifyContent: "flex-end", alignItems: "center", spacing: 1 },
                React.createElement(PeekBox, null,
                    React.createElement(StagedControl, null)),
                React.createElement(PeekBox, null,
                    React.createElement(FullScreenControl, { fullScreenElement: getContainer().parentElement }))))));
};

export { EditorBaseMenu, EditorBaseMenu as default };
